<div class="container" id="container" *ngIf="finishedLoading">
    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <h3>
                Karten-Historie
            </h3>
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef>
                        #
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                        {{i+1}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="ownendByRef">
                    <th mat-header-cell *matHeaderCellDef>
                        Aktueller Besitzer
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.ownendByRef}}
                    </td>
                </ng-container>


                <ng-container matColumnDef="modifiedByRef">
                    <th mat-header-cell *matHeaderCellDef>
                        Letzte Änderung durch
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.modifiedByRef}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>
                        Status
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        <mat-chip-set>
                            <mat-chip class="primaryChip" selected *ngIf="element.state == 'ACTIVE' ">
                                {{element.state | translateState}}
                            </mat-chip>
                            <mat-chip disabled *ngIf="element.state != 'ACTIVE' ">
                                {{element.state | translateState}}
                            </mat-chip>
                        </mat-chip-set>
                    </td>
                </ng-container>

                <ng-container matColumnDef="created">
                    <th mat-header-cell *matHeaderCellDef>
                        Letzte Änderung am

                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.created | date: 'medium' : 'GMT' : 'de-DE'}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
            </table>
            <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine
                passenden Einträge gefunden...
            </span>
        </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>